import { t } from "i18next";
import { useAppSelector } from "../../../redux/store";

const ServiceDescriptions = () => {
  const booking = useAppSelector((state) => state.booking);
  const transfers = booking.transfers.serviceDescriptions;

  return (
    <div>
      <p>
        <strong>{t("other.transfers")} </strong>
      </p>
      <ul className="mt-2">
        {transfers.map((transfer, i: any) => (
          <li key={i}>{transfer}</li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceDescriptions;
